import React, { useState } from "react";
import { Form, Modal, Button, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
// import { submitDemoRequest } from "../../../store/features/actions/demoRequestActions";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { submitDemoRequest } from "../../store/features/actions/demoRequestActions";

export default function AddDemoRequest({ handleClose = () => {} }) {
  const dispatch = useDispatch();
  // const [searchFilters, setSearchFilters] = useState({ search_string: "" });

  const [productListWrongDataError, setProductListWrongDataError] =
    useState(false);
  // const [csvData, setCsvData] = useState([]);
  // const [success_message, setSuccessMessage] = useState("");
  // const [error, setError] = useState("");
  const [customError, setCustomError] = useState({});
  // const [showDescriptionModal, setShowModal] = useState(false);

  const INDUSTRIES = [
    "Automation",
    "Aerospace & Defence",
    "Agriculture",
    "Automotive & Transportation",
    "BFSI",
    "Chemicals & Material",
    "Consulting",
    "Energy & Power",
    "Food & Beverage",
    "Healthcare",
    "Information & Communications Technology",
    "Packaging, Construction, Mining & Gases",
    "Semiconductor & Electronics",
  ];

  const account_types = [
    "Amplification", "Activation", "Value", "Growth", "Enterprise"
  ];

  const requiredHeaders = ["Product", "Description"];

  const [formData, setFormData] = useState({
    requestType: "",
    roundOfDemo: "",
    demoDateTime: "",
    question: "",
    sellerAccountName: "",
    buyerAccountName: "",
    sellerAccountWebsite: "",
    buyerAccountWebsite: "",
    sellerIndustry: "",
    buyerIndustry: "",
    noOfAccounts: "",
    noOfUsers: "",
    accountType: "",
    salesPersonNameAndDesignation: "",
    lead_id: "",
    icpNameAndDesignation: "",
    productListCsv: null,
    csvData: "",
    // demoStartTime: "",
    // demoCompletionTime: "",
    // email: "",
    // name: "",
    // readyState: "",
    // detailsSentToRequestor: "",
    // demoFeedback: "",
    // qcedByProduct: "",
    // qcedByResearch: "",
    // deliveredToRequestor: "",
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "productListCsv") {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.trim().split("\n");

        if (lines.length < 2) {
          setCustomError((prevErrors) => ({
            ...prevErrors,
            productListCsv: "CSV file is empty or missing data.",
          }));
          return;
        }

        const headers = lines[0].split(",").map((h) => h.trim());
        const missingHeaders = requiredHeaders.filter(
          (h) => !headers.includes(h)
        );

        if (missingHeaders.length > 0) {
          setCustomError((prevErrors) => ({
            ...prevErrors,
            productListCsvFormatError: `Missing required column(s): ${missingHeaders.join(
              ", "
            )}`,
          }));
          setProductListWrongDataError(true);
          return;
        } else {
          setProductListWrongDataError(false);
        }

        // Convert to JSON (enhanced CSV parsing)
        const json = lines.slice(1).map((line) => {
          const values = [];
          let current = "";
          let insideQuotes = false;

          for (let i = 0; i < line.length; i++) {
            const char = line[i];
            const nextChar = line[i + 1];

            if (char === '"' && !insideQuotes) {
              insideQuotes = true;
            } else if (char === '"' && insideQuotes) {
              if (nextChar === '"') {
                current += '"'; // Escaped quote
                i++; // Skip next quote
              } else {
                insideQuotes = false;
              }
            } else if (char === "," && !insideQuotes) {
              values.push(current.trim());
              current = "";
            } else {
              current += char;
            }
          }

          values.push(current.trim()); // push last value

          // Clean up quotes and escapes
          const cleanedValues = values.map((v) =>
            v.replace(/^"(.*)"$/, "$1").replace(/\\"/g, '"')
          );

          const obj = {};
          headers.forEach((header, i) => {
            obj[header] = cleanedValues[i] || "";
          });
          return obj;
        })
        .filter((row) => row[headers[0]].trim() !== "") // Filter out rows with empty product name
        .map((row) => ({
          name: row["Product"] || row["product"] || "",
          description: row["Description"] || row["description"] || "",
        }));

        // setCsvData(JSON.stringify(json));
        setFormData((prev) => ({
          ...prev,
          csvData: JSON.stringify(json),
          productListCsv: files[0], // store the file too if needed
        }));
        setCustomError((prevErrors) => ({
          ...prevErrors,
          productListCsv: "",
        }));
      };

      if (files?.[0] instanceof Blob) {
        reader.readAsText(files?.[0]);
      } else {
        setFormData({ ...formData, [name]: null });
        setCustomError((prevErrors) => ({
          ...prevErrors,
          productListCsv: "CSV file is empty or missing data.",
        }));
        return;
      }

      // setFormData({ ...formData, csvData: csvData });
      // setFormData({ ...formData, [name]: files[0] });

      setCustomError((prevErrors) => ({
        ...prevErrors,
        productListCsv: "",
        productListCsvFormatError: "",
      }));
    } else {
      setFormData({ ...formData, [name]: value });
      // Clear the error for the current field
      setCustomError((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newError = {};
    let isValid = true;
    const nameRegex = /^[a-zA-Z0-9 ]+$/; // allows letters, numbers, and spaces only

    const websiteUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;

    if (formData.requestType === "") {
      newError.requestType = "Request type required.";
      isValid = false;
    }

    if (formData.roundOfDemo === "") {
      newError.roundOfDemo = "Round of demo required.";
      isValid = false;
    }

    if (formData.demoDateTime === "") {
      newError.demoDateTime = "Demo date-time required.";
      isValid = false;
    }

    // const questionRegex = /^[a-zA-Z0-9 ?!.,'"()\-]+$/; // Customize allowed characters if needed

    if (!formData.question.trim()) {
      newError.question = "Question is required.";
      isValid = false;
    }
    // else if (!questionRegex.test(formData.question)) {
    //   newError.question = "Question contains invalid special characters.";
    //   isValid = false;
    // }

    if (!formData.sellerAccountName.trim()) {
      newError.sellerAccountName = "Seller Account Name is required.";
      isValid = false;
    } else if (!nameRegex.test(formData.sellerAccountName)) {
      newError.sellerAccountName =
        "Seller Account Name should not contain special characters.";
      isValid = false;
    }

    if (!formData.buyerAccountName.trim()) {
      newError.buyerAccountName = "Buyer Account Name is required.";
      isValid = false;
    } else if (!nameRegex.test(formData.buyerAccountName)) {
      newError.buyerAccountName =
        "Buyer Account Name should not contain special characters.";
      isValid = false;
    }

    // Website validation
    if (!formData.sellerAccountWebsite.trim()) {
      newError.sellerAccountWebsite = "Seller Account Website is required.";
      isValid = false;
    } else if (!websiteUrlRegex.test(formData.sellerAccountWebsite)) {
      newError.sellerAccountWebsite =
        "Enter valid Website url.";
      isValid = false;
    }

    if (!formData.buyerAccountWebsite.trim()) {
      newError.buyerAccountWebsite = "Buyer Account Website is required.";
      isValid = false;
    } else if (!websiteUrlRegex.test(formData.buyerAccountWebsite)) {
      newError.buyerAccountWebsite =
        "Enter valid Website url";
      isValid = false;
    }
    // End: Website validation


    const nameDesignationRegex = /^[a-zA-Z0-9 .,'\-&()]+$/; // Allows letters, numbers, space, basic punctuation

    if (!formData.sellerIndustry.trim()) {
      newError.sellerIndustry = "Seller industry is required.";
      isValid = false;
    } else if (!nameDesignationRegex.test(formData.sellerIndustry)) {
      newError.sellerIndustry = "Seller industry contains invalid characters.";
      isValid = false;
    }

    if (!formData.buyerIndustry.trim()) {
      newError.buyerIndustry = "Buyer industry is required.";
      isValid = false;
    } else if (!nameDesignationRegex.test(formData.buyerIndustry)) {
      newError.buyerIndustry = "Buyer industry contains invalid characters.";
      isValid = false;
    }

    const numberRegex = /^[0-9]+$/;

    if (!formData.noOfAccounts.trim()) {
      newError.noOfAccounts = "No of accounts is required.";
      isValid = false;
    } else if (!numberRegex.test(formData.noOfAccounts.trim())) {
      newError.noOfAccounts = "No of accounts must contain only numbers.";
      isValid = false;
    }

    if (!formData.noOfUsers.trim()) {
      newError.noOfUsers = "No of users is required.";
      isValid = false;
    } else if (!numberRegex.test(formData.noOfUsers.trim())) {
      newError.noOfUsers = "No of users must contain only numbers.";
      isValid = false;
    }

    if (!formData.accountType.trim()) {
      newError.accountType = "Account type is required.";
      isValid = false;
    }

    if (!formData.salesPersonNameAndDesignation.trim()) {
      newError.salesPersonNameAndDesignation =
        "Sales person name and designation is required.";
      isValid = false;
    } else if (
      !nameDesignationRegex.test(formData.salesPersonNameAndDesignation)
    ) {
      newError.salesPersonNameAndDesignation =
        "Sales person name and designation contains invalid characters.";
      isValid = false;
    }

    if (!formData.icpNameAndDesignation.trim()) {
      newError.icpNameAndDesignation = "ICP name and designation is required.";
      isValid = false;
    } else if (!nameDesignationRegex.test(formData.icpNameAndDesignation)) {
      newError.icpNameAndDesignation =
        "ICP name and designation contains invalid characters.";
      isValid = false;
    }

    if (!formData?.lead_id.trim()) {
      newError.lead_id = "Lead ID is required.";
      isValid = false;
    }

    if (formData.productListCsv == null) {
      newError.productListCsv = "Product list csv required.";
      isValid = false;
    } else if (productListWrongDataError) {
      // newError.productListCsv = "Missing required column(s): Product, Description";
      newError.productListCsvFormatError =
        "Missing required column(s): Product, Description";
      isValid = false;
    }

    setCustomError(newError);
    if (!isValid) return;

    // dispatch(submitDemoRequest(formData));
    dispatch(submitDemoRequest(formData));
    handleClose(false);
  };

  const isToday = (date) => {
    if (!date || !(date instanceof Date)) return false;
    return date.toDateString() === new Date().toDateString();
  };

  return (
    <Modal show="true" onHide={handleClose} centered className="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>Demo/Trial Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-md-12">
            <div htmlFor="labelCompanyName" className="form-label custom_label">
              {/* <h2 className="text-2xl font-bold mb-4">Demo Request Form</h2> */}
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group controlId="requestType">
                      <Form.Label>Request Type</Form.Label>
                      <Form.Select
                        className="popupInputStyle"
                        name="requestType"
                        value={formData.requestType}
                        onChange={handleChange}
                      >
                        <option value="">Select Request Type</option>
                        <option value="new">Demo</option>
                        <option value="update">Trial</option>
                      </Form.Select>
                      {customError.requestType && (
                        <p className="text-danger">{customError.requestType}</p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="roundOfDemo">
                      <Form.Label>Round of Demo</Form.Label>
                      <Form.Select
                        name="roundOfDemo"
                        className="popupInputStyle"
                        value={formData.roundOfDemo}
                        onChange={handleChange}
                      >
                        <option value="">Which Round of Demo ?</option>
                        <option value="1">1st</option>
                        <option value="2">2nd</option>
                        <option value="3">3rd</option>
                        <option value="4">4th</option>
                        <option value="5">5th</option>
                      </Form.Select>
                      {customError.roundOfDemo && (
                        <p className="text-danger">{customError.roundOfDemo}</p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="sellerAccountName">
                      <Form.Label>Seller Account Name</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="sellerAccountName"
                        value={formData.sellerAccountName}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.sellerAccountName && (
                        <p className="text-danger">
                          {customError.sellerAccountName}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="buyerAccountName">
                      <Form.Label>Buyer Account Name</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="buyerAccountName"
                        value={formData.buyerAccountName}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.buyerAccountName && (
                        <p className="text-danger">
                          {customError.buyerAccountName}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group controlId="sellerAccountWebsite">
                      <Form.Label>Seller Account Website</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="sellerAccountWebsite"
                        value={formData.sellerAccountWebsite}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.sellerAccountWebsite && (
                        <p className="text-danger">
                          {customError.sellerAccountWebsite}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="buyerAccountWebsite">
                      <Form.Label>Buyer Account Website</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="buyerAccountWebsite"
                        value={formData.buyerAccountWebsite}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.buyerAccountWebsite && (
                        <p className="text-danger">
                          {customError.buyerAccountWebsite}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group controlId="sellerIndustry">
                      <Form.Label>Seller Industry</Form.Label>
                      <Form.Select
                        name="sellerIndustry"
                        className="popupInputStyle"
                        value={formData.sellerIndustry}
                        onChange={handleChange}
                      >
                        <option value="">Select an industry</option>
                        {INDUSTRIES.map((industry) => (
                          <option key={industry} value={industry}>
                            {industry}
                          </option>
                        ))}
                      </Form.Select>
                      {customError.sellerIndustry && (
                        <p className="text-danger">
                          {customError.sellerIndustry}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="buyerIndustry">
                      <Form.Label>Buyer Industry</Form.Label>
                      <Form.Select
                        name="buyerIndustry"
                        className="popupInputStyle"
                        value={formData.buyerIndustry}
                        onChange={handleChange}
                      >
                        <option value="">Select an industry</option>
                        {INDUSTRIES.map((industry) => (
                          <option key={industry} value={industry}>
                            {industry}
                          </option>
                        ))}
                      </Form.Select>
                      {customError.buyerIndustry && (
                        <p className="text-danger">
                          {customError.buyerIndustry}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  {/* +++++++++++++++++++++++++++++++++++ */}
                  <Col md={6}>
                    <Form.Group controlId="noOfAccounts">
                      <Form.Label>No of Accounts</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="noOfAccounts"
                        value={formData.noOfAccounts}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.noOfAccounts && (
                        <p className="text-danger">
                          {customError.noOfAccounts}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="noOfUsers">
                      <Form.Label>No of Users</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="noOfUsers"
                        value={formData.noOfUsers}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.noOfUsers && (
                        <p className="text-danger">
                          {customError.noOfUsers}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="accountType">
                      <Form.Label>Account Type</Form.Label>
                      <Form.Select
                        name="accountType"
                        className="popupInputStyle"
                        value={formData.accountType}
                        onChange={handleChange}
                      >
                        <option value="">Select account type</option>
                        {account_types.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </Form.Select>
                      {customError.accountType && (
                        <p className="text-danger">
                          {customError.accountType}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  {/* +++++++++++++++++++++++++++++++++++ */}

                  {/* <Col md={6}>
                          <Form.Group controlId="demoStartTime">
                            <Form.Label>Demo Start Time</Form.Label>
                            <Form.Control
                              type="datetime-local"
                              className="popupInputStyle"
                              name="demoStartTime"
                              value={formData.demoStartTime}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="demoCompletionTime">
                            <Form.Label>Completion Time</Form.Label>
                            <Form.Control
                              type="datetime-local"
                              className="popupInputStyle"
                              name="demoCompletionTime"
                              value={formData.demoCompletionTime}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col> */}

                  {/* <Col md={6}>
                          <Form.Group controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              className="popupInputStyle"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              className="popupInputStyle"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col> */}

                  <Col md={6}>
                    <Form.Group controlId="demoDateTime">
                      <Form.Label>
                        Demo Date & Time{" "}
                        <span style={{ fontSize: "0.9em", color: "gray" }}>
                          (All times are in IST)
                        </span>
                      </Form.Label>
                      {/* <Form.Control
                              type="datetime-local"
                              className="popupInputStyle"
                              name="demoDateTime"
                              value={formData.demoDateTime}
                              onChange={handleChange}
                            /> */}
                      <DatePicker
                        name="demoDateTime"
                        selected={formData.demoDateTime}
                        showTimeSelect
                        onChange={(date) => {
                          setFormData({ ...formData, demoDateTime: date });
                          setCustomError((prevErrors) => ({
                            ...prevErrors,
                            demoDateTime: "",
                          }));
                        }}
                        timeIntervals={60}
                        timeCaption="Time"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeFormat="h aa"
                        className="form-control popupInputStyle"
                        minDate={new Date()}
                        minTime={
                          isToday(formData.demoDateTime)
                            ? new Date()
                            : new Date(new Date().setHours(0, 0, 0, 0))
                        }
                        maxTime={new Date(new Date().setHours(23, 59))}
                        autoComplete="off"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {customError.demoDateTime && (
                        <p className="text-danger">
                          {customError.demoDateTime}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="productListCsv">
                      <Form.Label>
                        Product List (CSV)
                        <a
                          href="../sample_files/Sample Product List.csv"
                          download
                          className="ml-2 mt-2 text-primary"
                        >
                          Sample
                        </a>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        className="popupInputStyle"
                        name="productListCsv"
                        accept=".csv"
                        onChange={handleChange}
                        // required
                      />
                      {customError.productListCsv && (
                        <p className="text-danger">
                          {customError.productListCsv}
                        </p>
                      )}
                      {customError.productListCsvFormatError && (
                        <p className="text-danger">
                          {customError.productListCsvFormatError}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="salesPersonNameAndDesignation">
                      <Form.Label>
                        Mnm Salesperson Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="salesPersonNameAndDesignation"
                        value={formData.salesPersonNameAndDesignation}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.salesPersonNameAndDesignation && (
                        <p className="text-danger">
                          {customError.salesPersonNameAndDesignation}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="icpNameAndDesignation">
                      <Form.Label>ICP Name & Designation</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="icpNameAndDesignation"
                        value={formData.icpNameAndDesignation}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.icpNameAndDesignation && (
                        <p className="text-danger">
                          {customError.icpNameAndDesignation}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="lead_id">
                      <Form.Label>CRM Lead ID</Form.Label>
                      <Form.Control
                        type="text"
                        className="popupInputStyle"
                        name="lead_id"
                        value={formData.lead_id}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.lead_id && (
                        <p className="text-danger">
                          {customError.lead_id}
                        </p>
                      )}
                    </Form.Group>
                  </Col>

                  {/* <Col md={6}>
                          <Form.Group controlId="readyState">
                            <Form.Label>Ready State</Form.Label>
                            <Form.Select
                              name="readyState"
                              className="popupInputStyle"
                              value={formData.readyState}
                              onChange={handleChange}
                            >
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="detailsSentToRequestor">
                            <Form.Label>Details Sent to Requestor?</Form.Label>
                            <Form.Select
                              name="detailsSentToRequestor"
                              className="popupInputStyle"
                              value={formData.detailsSentToRequestor}
                              onChange={handleChange}
                            >
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="demoFeedback">
                            <Form.Label>Demo Feedback</Form.Label>
                            <Form.Control
                              type="text"
                              className="popupInputStyle"
                              name="demoFeedback"
                              value={formData.demoFeedback}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="qcedByProduct">
                            <Form.Label>Qced By Product Team</Form.Label>
                            <Form.Control
                              type="text"
                              className="popupInputStyle"
                              name="qcedByProduct"
                              value={formData.qcedByProduct}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="qcedByResearch">
                            <Form.Label>Qced By Research Team</Form.Label>
                            <Form.Control
                              type="text"
                              className="popupInputStyle"
                              name="qcedByResearch"
                              value={formData.qcedByResearch}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group controlId="deliveredToRequestor">
                            <Form.Label>Delivered to Requestor?</Form.Label>
                            <Form.Select
                              name="deliveredToRequestor"
                              className="popupInputStyle"
                              value={formData.deliveredToRequestor}
                              onChange={handleChange}
                            >
                              <option value="">Select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </Form.Select>
                          </Form.Group>
                        </Col> */}

                  <Col md={12}>
                    <Form.Group controlId="question">
                      <Form.Label>What are they looking for ?</Form.Label>
                      <textarea
                        type="textarea"
                        className="popupInputStyle form-control"
                        rows={3}
                        name="question"
                        value={formData.question}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {customError.question && (
                        <p className="text-danger">{customError.question}</p>
                      )}
                    </Form.Group>
                    {/* <Form.Group controlId="productListCsv">
                      <Form.Label>
                        Product List (CSV)
                        <a
                          href="../sample_files/Sample Product List.csv"
                          download
                          className="ml-2 mt-2 text-primary"
                        >
                          Sample
                        </a>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        className="popupInputStyle"
                        name="productListCsv"
                        accept=".csv"
                        onChange={handleChange}
                        // required
                      />
                      {customError.productListCsv && (
                        <p className="text-danger">
                          {customError.productListCsv}
                        </p>
                      )}
                      {customError.productListCsvFormatError && (
                        <p className="text-danger">
                          {customError.productListCsvFormatError}
                        </p>
                      )}
                    </Form.Group> */}
                  </Col>
                </Row>

                <div className="d-flex justify-content-end mt-4 gap-2">
                  <Button
                    variant="secondary"
                    onClick={handleClose}
                    className="cancel_button_demo_request"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    className="submit_button_demo_request"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
